import { render, staticRenderFns } from "./StandardValues.vue?vue&type=template&id=7276ff2f&"
import script from "./StandardValues.vue?vue&type=script&lang=js&"
export * from "./StandardValues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports